<template>
  <!-- 文章列表 -->
    <operateButton @btn-handle="btnHandle" @btn-in-table="btnInTable"
        :style="btnLeftList.length > 0 ? '' : 'display:block;'" @btn-on-left="btnOnList" />
  <el-button-group v-if="false">
    <el-button type="primary" size="large" @click="addFnc($event)">
      <el-icon>
        <Plus />
      </el-icon>
      &nbsp;添加文章
    </el-button>
    <el-button type="primary" @click="editFnc($event)" class="edit" plain size="large"
            ><el-icon><EditPen /></el-icon>&nbsp;编辑</el-button
        >
      <el-button type="primary" @click="grounding($event)" class="edit" plain size="large"
          ><el-icon><Top /></el-icon>&nbsp;批量上架</el-button
      >
      <el-button type="primary" @click="offshelf($event)" class="edit" plain size="large"
          ><el-icon><Bottom /></el-icon>&nbsp;批量下架</el-button
      >
    <!-- <el-tooltip placement="top">
      <template #content>选择相应[文章]数据动态更新PC端[文章内容]页</template>
      <el-button type="primary" size="large" @click="releaseFnc($event)"
      >
        <el-icon>
          <Position/>
        </el-icon>
        发布
      </el-button
      >
    </el-tooltip> -->
    <el-button type="danger" size="large" plain @click="deleteFnc($event)"  v-if="isDelect"
      ><el-icon><DeleteFilled /></el-icon>&nbsp;批量删除
    </el-button>
  </el-button-group>
  <!-- 表格组件 -->
  <TableList
    componentTableId="ArticleList"
    @update-list="updateList"
    excelName="文章列表"
    :table-data="tableData"
    :header-data="headerData"
    :table-height="
        btnLeftList.length > 0 ? tableMaxHeight : tableMaxHeight + 40
      "
    :loading="loading"
    :loading-text="loadingText"
    :empty-text="emptyText"
    @editFnc="editFnc"
    @searchFnc="searchFnc"
    @openContent="openContent"
    @handleSelection="handleSelection"
    @changeCascader="changeCascader"
    @changeRelevance="changeRelevance"
  >
     <!-- 列表按钮操作动态 -->
      <template #inTableCustom="scope">
        <div class="optionDiv" style="white-space: nowrap; display: inline-block; float: left">
          <el-button-group style="display: flex" v-if="buttonList && buttonList.length > 1">
            <el-tooltip :content="item.tip ? item.tip : item.name" v-for="(item, index) in buttonList" placement="top"
              :disabled="!item.tip">
              <el-button size="default" :type="item.className" @click="doEvent(item.eventName, scope.scope)"
                :plain="!item.isPlain" :icon="item.icon">{{ item.name }}</el-button>
            </el-tooltip>
          </el-button-group>
          <div v-else>
            <el-tooltip :content="item.tip ? item.tip : item.name" v-for="(item, index) in buttonList" placement="top"
              :disabled="!item.tip">
              <el-button size="default" :type="item.className" @click="doEvent(item.eventName, scope.scope)"
                :plain="!item.isPlain" :icon="item.icon">{{ item.name }}</el-button>
            </el-tooltip>
          </div>
        </div>
      </template>
    <template #titleCustom="scope">
      <span class="hand blue" @click="openCourseDetail(scope.scope)">{{
        scope.scope.title
      }}</span>
    </template>
    <template #channelCountCustom="scope">
      <span
        v-if="scope.scope.channelCount > 0"
        class="hand blue"
        @click="openChannelCount(scope.scope)"
        >已关联{{ scope.scope.channelCount }}个专题/院校</span
      >
      <span class="gray" v-else>未设置</span>
    </template>
    <template #channelCountTitle="scope">
      <el-popover placement="bottom" :width="inputFiltrate?440:240" trigger="click">
          <!-- <div class="table-title" style="width: 100%;"> -->
            <!-- 下拉框和输入框搜索联合popover-->
            <el-row :span="24">
                  <el-col :span="12">
                    <el-select
                      :teleported="false"
                      style="width: 200px"
                      v-model="search.relevanceType"
                      class="m-2"
                      placeholder="关联专题/院校(全部)"
                      size="large"
                      clearable
                      @change="changeRelevanceType"
                    >
                      <el-option
                        @click="changeRelevanceType"
                        v-for="item in specialTypesList2"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key"
                      />
                    </el-select>
                  </el-col>
                  <el-col :span="12" v-if="inputFiltrate">
                    <el-tooltip
                      content="请先选择关联类别，再进行搜索"
                      placement="top"
                    >
                      <el-input
                        style="width: 200px"
                        v-model="search.keyword"
                        class="m-2"
                        placeholder='请输入关键字搜索'
                        size="large"
                        clearable
                        @clear="searchFnc({prop:'channelCount'})"
                      >
                        <template #suffix>
                          <el-icon @click="searchFnc({prop:'channelCount'})" clearable
                            ><Search
                          /></el-icon>
                        </template>
                      </el-input>
                    </el-tooltip>
                  </el-col>
                </el-row>
          <!-- </div> -->
          <template  #reference>
            <div class="search-header hand">
              <span class="search-title">关联专题/院校</span>
              &nbsp;<el-icon style="vertical-align: middle">
                <Search />
              </el-icon>
            </div>
          </template >
        </el-popover>
    </template>
  </TableList>
  <!-- 底部工具 -->
  <Pagination
    :pagination="pagination"
    :is-loading="loading"
    @change-pagination="changePagination"
  >
  </Pagination>
  <!-- 添加编辑 文章 -->
  <el-dialog
    class="dialogNoPadding"
    :before-close="handleClose"
    :close-on-click-modal="false"
    v-model="addEditVisible"
    :title="dialogTitle"
    :width="isFullscreen ? '100vw' : '900px'"
    :top="isFullscreen ? '0' : '15vh'"
    :fullscreen="isFullscreen"
    append-to-body="false"
    draggable
    destroy-on-close
  >
    <template #header>
      <div class="full-screen" style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
        <span class="dialog-title">{{ dialogTitle }}</span>
        <span style="display: flex; align-items: center;">
          <el-button type="text" @click="toggleFullscreen" style="margin-right: 2px;">
            <el-icon v-if="!isFullscreen"><FullScreen /></el-icon>
            <el-icon v-else><Minus /></el-icon>
          </el-button>
        </span>
      </div>
      <!-- <div class="dialog-header-btns">
        <span style="display: flex; align-items: center;">
          <el-button type="text" @click="toggleFullscreen" style="margin-right: 2px;">
            <el-icon v-if="!isFullscreen"><FullScreen /></el-icon>
            <el-icon v-else><Minus /></el-icon>
          </el-button>
        </span>
      </div> -->
    </template>
    <AddEditarticleList
      ref="AddEditComponent"
      v-if="addEditVisible"
      :edit-id="editId"
      :category-list="categoryList"
      :types-list="typesList"
      :is-fullscreen="isFullscreen"
      @close-dialog="closeDialog"
      @update-list="updateList"
    ></AddEditarticleList>
  </el-dialog>
  <!-- 打开前台移动端 -->
  <el-dialog
    :close-on-click-modal="false"
    v-model="UrlOpenFlag"
    :title="selectTitle"
    width="400px"
    append-to-body="false"
    draggable
    destroy-on-close
  >
    <OpenMobile
      ref="UrlOpen"
      v-if="UrlOpenFlag"
      :url="mobileUrl"
      :studentDialogTitle="selectTitle"
    >
    </OpenMobile>
  </el-dialog>

  <!-- 文章关联专题-->
  <el-dialog
    :close-on-click-modal="false"
    v-model="relevanceVisible"
    title="文章关联专题/院校"
    width="900px"
    append-to-body="false"
    draggable
    destroy-on-close
  >
    <el-table
      :data="relevanceTable"
      border
      style="width: 100%; height: 540px; margin-top: 10px"
      :header-cell-style="{ background: '#f5f7fa' }"
      :row-style="{ height: '0' }"
      :cell-style="{ padding: '8px' }"
    >
      <el-table-column
        prop="relevanceType"
        label="关联类型"
        align="center"
        width="300"
      />
      <el-table-column
        prop="relevanceName"
        label="专题/院校名称"
        align="center"
      >
        <template #default="scope">
          <span v-if="scope.row.relevanceName == null" class="gray"
            >未设置</span
          >
          <span v-else>{{ scope.row.relevanceName }}</span>
        </template></el-table-column
      >
    </el-table>
  </el-dialog>
  <!-- 批量操作结果响应 -->
  <el-dialog
    :close-on-click-modal="false"
    v-model="resultVisible"
    title="提示"
    width="900px"
    append-to-body="false"
    draggable
    destroy-on-close
  >
  <ResultList></ResultList>
  </el-dialog>
</template>

<script>
import TableList from "@/components/TableHeaderCom/index.vue";
// import TableList from "@/components/TableList.vue";
import Pagination from "components/Pagination.vue";
import ResultList from "@/components/ResultList.vue"
import { reactive, onMounted, toRefs, ref, toRaw, h, computed,defineExpose, nextTick } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { lostFocus } from "common/utils";
import store from "../../store/index";
import { getCategoryPag, UpdateArticleIsOut } from "network/articleClassification.js";
import {
  getPage,
  deletesArticle,
  getAllSpecialTopicTypes,
  getArticleRelevance,
  ArticleHtml,
} from "network/articleList.js";
import constGlobal from "common/global.js";
import AddEditarticleList from "views/articleList/AddEditarticleList.vue";
import OpenMobile from "components/OpenMobile"
export default {
  name: "ArticleList",
  props: {
    tableMaxHeight: Number,
  },
  components: {
    TableList,
    Pagination,
    AddEditarticleList,
    OpenMobile,
    ResultList
  },
  emits: ["addTab"],
  setup(props, { emit }) {

    //这里定义一个结构体，用来保存项目信息
    const isFullscreen = ref(false);
    const toggleFullscreen = () => {
      isFullscreen.value = !isFullscreen.value;
    };
    const data = reactive({
      // 登录状态
      AdminCache: computed(() => {
        return (
          store.state.AdminCache ||
          JSON.parse(sessionStorage.getItem("AdminCache"))
        );
      }),
      // 登录状态
      AdminInfo: computed(() => {
        return (
          store.state.AdminInfo ||
          JSON.parse(sessionStorage.getItem("AdminInfo"))
        );
      }),
      isDelect: computed(() => {
        return (
          store.state.isDelect ||
          JSON.parse(sessionStorage.getItem("isDelect"))
        );
      }),
      roleId:computed(() => store.state.AdminCache.roleId || sessionStorage.getItem("AdminCache").roleId),
      configRoleId:computed(() => store.state.AdminCache.configRoleId || sessionStorage.getItem("AdminCache").configRoleId),
      UrlOpenFlag: false, //打开前台移动端
      mobileUrl: "", // 跳转前台移动端url
      selectTitle: "",
      // 表格是否在加载中
      loading: true,
      loadingText: "加载中...",
      emptyText: "暂无数据",
      resultVisible: false,
      // 分页
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      inputFiltrate:false,
      selectType:null,// 关联专题
      specialTypesList2:[],
      //表格数据
      tableData: [],
      //表头数据
      headerData: [
        {
          label: "勾选框",
          type: "selection",
          width: "55",
          fixed: "left",
        },
        //加一列id
        {
          label: "id",
          prop: "id",
          width: "100",
          align: "center",
          noSetText: "未设置",
          fixed:"left",
        },
        {
          label: "标题",
          prop: "title",
          width: "300",
          align: "left",
          noSetText: "未设置",
          type: "InputSearch",
          fixed: "left",
          custom: true,
        },
        {
          label: "所属分类",
          prop: "categoryTitle",
          width: "200",
          align: "center",
          noSetText: "未设置",
          type: "CascaderSelect",
          cascaderOptions: [],
          cascaderChildren: "children",
          catrgoryOptions: [],
          checkStrictly:true
        },
        {
          label: "文章来源",
          prop: "source",
          width: "180",
          align: "center",
          noSetText: "未设置",
          type: "SelectSearch",
          selectOptions: [],
        },
        {
          label: "关联专题/院校",
          prop: "channelCount",
          width: "160",
          align: "center",
          noSetText: "未设置",
          // type: "SelectInputSearch",
          // selectPlaceholder: "关联类别",
          // inputPlaceholder: "关键字",
          // selectOptions: [],
          custom: true,
          slotTitle: true,
          type: "InputSearch",
        },

        {
          label: "作者名称",
          prop: "adminName",
          width: "100",
          align: "center",
          noSetText: "未设置",
        },
        {
          label: "是否推荐",
          prop: "istj",
          width: "180",
          align: "center",
          noSetText: "未设置",
          isTag: true,
          type: "SelectSearch",
          istj: -1,
          selectOptions: [{
            key:-1,
            value:"是否推荐(全部)"
          },{
            key:1,
            value:"是"
          },{
            key:0,
            value:"否"
          }
        ],
        },
        {
          label: "是否焦点",
          prop: "isjd",
          width: "180",
          align: "center",
          noSetText: "未设置",
          isTag: true,
          type: "SelectSearch",
          isjd: -1,
          selectOptions: [{
            key:-1,
            value:"是否焦点(全部)"
          },{
            key:1,
            value:"是"
          },{
            key:0,
            value:"否"
          }
        ],
        },
        {
          label: "是否评论",
          prop: "ispl",
          width: "180",
          align: "center",
          noSetText: "未设置",
          isTag: true,
          type: "SelectSearch",
          ispl:-1,
          selectOptions: [{
            key:-1,
            value:"是否评论(全部)"
          },{
            key:1,
            value:"是"
          },{
            key:0,
            value:"否"
          }
        ],
        },
        {
          label: "是否下架",
          prop: "isOut",
          width: "100",
          align: "center",
          noSetText: "未设置",
          isTag: true,
        },
        {
          label: "发布时间",
          prop: "createTime",
          width: "200",
          align: "center",
          noSetText: "未设置",
        },
        {
          label: "编辑时间",
          prop: "updateTime",
          width: "200",
          align: "center",
          noSetText: "未设置",
        },
        {
          label: "更新时间",
          prop: "editTime",
          width: "200",
          align: "center",
          noSetText: "未设置",
        },
        
      ],
      multipleSelection: [], //选中行数据
      //筛选项
      search: {
        categoryOneId: null, //分类一级筛选
        categoryId: null, //分类二级筛选
        title: null,
        isjd: null,
        istj: null,
        ispl: null,
        source: null, //所选文章来源
        channelId: null,
        relevanceType: null, //关联类别筛选
        keyword: null, //关联-关键字筛选
        articleContent: null,
      },
      categoryList: [], //全部分类
      articleSourcesList: [], //文章来源
      specialTypesList: [], //关联类别
      dialogTitle: "添加文章",
      addEditVisible: false, //添加编辑弹窗
      editId: 0,
      relevanceVisible: false, //关联专题弹窗
      relevanceTable: [], //关联专题院校 表格
      relevancekeyword: '',//关联专题院校关键字
    });

    //挂载后调用函数获取项目数据
    onMounted(() => {
      getSpecialTypes(); //获取关联专题/院校的类别
      getCategoryAll(); //获取全部所属分类
      getArticleList(); //请求文章列表数据
    });

    // 关联专题/院校的类别
    function getSpecialTypes() {
      getAllSpecialTopicTypes()
        .then((result) => {
          if (result && result.code == 1) {
            data.specialTypesList = result.result;
            // data.headerData.map((item) => {
            //   if (item.prop == "channelCount") {
            //     item.selectOptions = data.specialTypesList;
            //   }
            // });
            data.specialTypesList2 = [
              {key:null,value:'关联专题/院校(全部)'},
              ...data.specialTypesList
            ]
          } else {
            ElMessage.error(result.messag);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }

    //获取全部所属分类
    function getCategoryAll() {
      getCategoryPag()
        .then((res) => {
          if (res.code == 1) {
            const list = res.result;
            data.categoryList = toRaw(list);
            data.headerData.map((item) => {
              if (item.prop == "categoryTitle") {
                item.catrgoryOptions = data.categoryList;
              }
            });
          } else {
            ElMessage.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    const changeRelevanceType = (obj) => {
      data.search.keyword = "";
      if (
        data.search.relevanceType == 1 ||
        data.search.relevanceType == 2 ||
        data.search.relevanceType == 3
      ) {
        data.inputFiltrate = true;
      } else {
        data.search.relevanceType = null;
        data.inputFiltrate = false;
        data.pagination.currentPage = 1;
        getArticleList();
      }
    };
    //选择所属分类
    const changeCascader = (obj) => {
      data.search.categoryOneId = obj.categoryOneId;
      data.search.categoryId = obj.categoryId;
      getArticleList();
    };

    //选择关联类别及关键字
    const changeRelevance = (obj) => {
      data.search.relevanceType = obj.type;
      data.search.keyword = obj.keyword;
      getArticleList();
    };

    // 获取列表
    const getArticleList = () => {
      data.loading = true;
      const obj = {
        categoryOneId: data.search.categoryOneId || null,
        categoryId: data.search.categoryId || null,
        title: data.search.title,
        isjd: data.search.isjd,
        istj: data.search.istj,
        ispl: data.search.ispl,
        source: data.search.source || null,
        channelId: data.search.channelId,
        relevanceType: data.search.relevanceType,
        keyword: data.search.keyword,
        articleContent: data.search.articleContent,
        pageIndex: data.pagination.currentPage,
        pageSize: data.pagination.pageSize,
      };
      getPage(obj)
        .then((result) => {
          data.articleSourcesList = result.result.articleSources;
          data.headerData.map((item) => {
            if (item.prop == "source") {
              item.selectOptions = constGlobal.articleSource;
            }
          });
          if (result && result.code == 1) {
            const list = result.result.articleList;
            data.pagination.total = result.result.totalCount;
            // 接口返回的是否是1 0，这里格式化 便于表格组件渲染标签
            list.forEach((item) => {
              item.isjd = item.isjd == 0 ? false : true;
              item.ispl = item.ispl == 0 ? false : true;
              item.istj = item.istj == 0 ? false : true;
            });
            data.tableData = list;
            data.loading = false;
          } else {
            data.loading = false;
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };
    // 跳转前台对应课程详情页
    const UrlOpen = ref()
    const openCourseDetail = (item) => {
      ElMessageBox({
        title: "预览提示",
        message: h("p", null, [
          h("span", null, "查看文章 "),
          h("span", null, `[${item.title}]`),
          h("span", null, "详情，请选择打开端口 "),
        ]),
        showCancelButton: true,
        confirmButtonText: "打开电脑端",
        cancelButtonText: "打开移动端",
        customClass: "msgbox-custom",
        distinguishCancelAndClose: true, //该属性可区分用户点击的是cancel取消按钮，还是close关闭，设为false时默认均为cancel
      }).then((action) => {
        if (action === "confirm") {
            let name = ''
            if(item.categoryOneName=='普通专升本'){
              name = '/ptzsb/news/'
            }else if (item.categoryOneName=='开放教育'){
              name = '/gkzsb/news/'
            }else if (item.categoryOneName=='成考专升本'){
              name = '/ckzsb/news/'
            }else if (item.categoryOneName=='自考专升本'){
              name = '/zkzsb/news/'
            }
            window.open(
              data.AdminInfo.sitePcWebUrl + name + item.id + ".html"
            );
          }
        }).catch((action) => {
          if(action === "cancel"){
            let name = ''
            if(item.categoryOneName=='普通专升本'){
              name = '/ptzsb/news/'
            }else if (item.categoryOneName=='开放教育'){
              name = '/gkzsb/news/'
            }else if (item.categoryOneName=='成考专升本'){
              name = '/ckzsb/news/'
            }else if (item.categoryOneName=='自考专升本'){
              name = '/zkzsb/news/'
            }
            var url =
              data.AdminInfo.siteMobileWebUrl + name + item.id + '.html';
            if (item.title && item.title != null && item.title != "") {
              data.UrlOpenFlag = true;
              data.selectTitle = "查看文章[" + item.title + "]详情";
              data.mobileUrl = url;
            }
          }
      });
    };
    // 搜索
    const searchFnc = (val) => {
      if (val.prop && val.prop == "title") {
        data.search.title = val.value;
      }
      if (val.prop && val.prop == "source") {
        data.search.source = val.value;
      }
      if (val.prop && val.prop == "istj") {
        if(val.value!==""){
          data.search.istj = val.value;
        }else{
          data.search.istj = null;
        }  
      }
      if (val.prop && val.prop == "isjd") {
        if(val.value!==""){
          data.search.isjd = val.value;
        }else{
          data.search.isjd = null;
        }  
      }
      if (val.prop && val.prop == "ispl") {
        if(val.value!==""){
          data.search.ispl = val.value;
        }else{
          data.search.ispl =null;
        }  
      }
      if (val.prop && val.prop == "categoryTitle"){
        data.search.categoryOneId = val.categoryOneId;
        data.search.categoryId = val.categoryId;
      
      }
      // if(val.prop && val.prop == 'channelCount' && !data.search.keyword){
        
      //   data.search.relevanceType = null
      //   data.inputFiltrate = false;
      // }
      
      data.pagination.currentPage = 1;
      getArticleList();
    };

    //更新列表
    const updateList = () => {
      getArticleList();
    };
    defineExpose({ updateList });
    // 添加文章
    const addFnc = () => {
      // 强制移除按钮焦点
      // lostFocus(e);
      isFullscreen.value = false; // 每次打开都最小化
      data.addEditVisible = true;
      data.dialogTitle = "添加文章";
      data.editId = 0;
    };
    // 上架文章
    const grounding = () => {
      if (data.multipleSelection.length == 0) {
        ElMessage.error("请选择要上架的文章");
        return false;
      }
      var deleteIds = [];
      data.multipleSelection.forEach(function (e) {
        deleteIds.push(e.id);
      });
      ElMessageBox({
        title: "提示",
        message: h("p", null, [
          h("span", null, "是否要上架【"),
          h(
            "b",
            { style: "color: #fd5252;font-size:16px" },
            `${data.multipleSelection.length}`
          ),
          h("span", null, "】篇文章？ "),
        ]),
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确认",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // 开启按钮加载
            instance.confirmButtonLoading = true
            instance.confirmButtonText = "确认中"
            
            UpdateArticleIsOut(deleteIds, false)
            .then((result) => {
              if (result && result.code == 1) {
                done();
                // data.resultVisible = true
                ElMessageBox.alert(result.message, "提示", {
                  confirmButtonText: "确定",
                });
                updateList();
              } else {
                done();
                // data.resultVisible = true
                ElMessageBox.alert(result.message, "提示", {
                  confirmButtonText: "确定",
                });
              }
            })
            .catch((err) => {
              done();
              // data.resultVisible = true
              ElMessageBox.alert(err.message, "提示", {
                  confirmButtonText: "确定",
                });
            })
          } else {
            done();
          }
        },
      })
        .catch(() => {
          ElMessage("取消删除");
        });
    };
    // 下架文章
    const offshelf = () => {
      if (data.multipleSelection.length == 0) {
        ElMessage.error("请选择要下架的文章");
        return false;
      }
      var deleteIds = [];
      data.multipleSelection.forEach(function (e) {
        deleteIds.push(e.id);
      });
      ElMessageBox({
        title: "提示",
        message: h("p", null, [
          h("span", null, "是否要下架【"),
          h(
            "b",
            { style: "color: #fd5252;font-size:16px" },
            `${data.multipleSelection.length}`
          ),
          h("span", null, "】篇文章？ "),
        ]),
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确认",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // 开启按钮加载
            instance.confirmButtonLoading = true
            instance.confirmButtonText = "确认中"
            
            UpdateArticleIsOut(deleteIds, true)
            .then((result) => {
              if (result && result.code == 1) {
                done();
                // ElMessage.success(result.message);
                ElMessageBox.alert(result.message, "提示", {
                  confirmButtonText: "确定",
                });
                updateList();
              } else {
                done();
                ElMessageBox.alert(result.message, "提示", {
                  confirmButtonText: "确定",
                });
              }
            })
            .catch((err) => {
              done();
              ElMessageBox.alert(err.message, "提示", {
                  confirmButtonText: "确定",
                });
            })
          } else {
            done();
          }
        },
      })
        .catch(() => {
          ElMessage("取消删除");
        });
      
    };
    // 编辑文章
    const editFnc = () => {
      // 强制移除按钮焦点
      if (data.multipleSelection.length == 0) {
        ElMessage.error("请选择要编辑的文章");
        return false;
      }
      if (data.multipleSelection.length > 1) {
        ElMessage.error("一次只能编辑一篇文章");
        return false;
      }
      isFullscreen.value = false; // 每次打开都最小化
      data.addEditVisible = true;
      data.dialogTitle = "编辑文章";
      data.editId = data.multipleSelection[0].id;
    };

    // 删除
    const deleteFnc = () => {
      // 强制移除按钮焦点
       if (data.multipleSelection.length == 0) {
        ElMessage.error("请选择要删除的文章");
        return false;
      }
      var deleteIds = [];
      data.multipleSelection.forEach(function (e) {
        deleteIds.push(e.id);
      });
      ElMessageBox({
        title: "提示",
        message: h("p", null, [
          h("span", null, "是否删除选中【"),
          h(
            "b",
            { style: "color: #fd5252;font-size:16px" },
            `${data.multipleSelection.length}`
          ),
          h("span", null, "】个文章？ "),
        ]),
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确认",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // 开启按钮加载
            instance.confirmButtonLoading = true
            instance.confirmButtonText = "确认中"
            // 删除接口
            deletesArticle(deleteIds)
            .then((result) => {
              if (result && result.code == 1) {
                done();
                ElMessage.success(result.message);
                updateList();
              } else {
                done();
                ElMessage.error(result.message);
              }
            })
            .catch((err) => {
              done();
              ElMessage.error(err.message);
            })
          } else {
            done();
          }
        },
      })
        // .then(() => {
        //   deleteData(deleteIds);
        // })
        .catch(() => {
          ElMessage("取消删除");
        });
    };

    function deleteData(ids) {
      deletesArticle(ids)
        .then((result) => {
          if (result && result.code == 1) {
            ElMessage.success(result.message);
            updateList();
          } else {
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }

    //关闭弹窗
    const closeDialog = () => {
      data.addEditVisible = false;
      data.editId = 0;
    };
    const resultHandle = (result) => {
           
      if(result?.result.length){
        data.resultVisible = true
        data.resultList = result.result
        data.resultTitle = '审核详情'
      }else{
        ElMessageBox.alert(result.message, "提示", {
          confirmButtonText: "确认",
        });
      }
    }

    // 分页
    const changePagination = (val) => {
      data.pagination = toRaw(val);
      updateList();
    };

    // 表格多选行处理
    const handleSelection = (row) => {
      data.multipleSelection = JSON.parse(JSON.stringify(row));
    };

    //打开关联表格展示弹窗
    const openChannelCount = (row) => {
      getArticleRelevance(row.id)
        .then((result) => {
          if (result && result.code == 1) {
            data.relevanceVisible = true;
            data.relevanceTable = result.result;
            // 格式化类型id为名称
            for (let i = 0; i < data.relevanceTable.length; i++) {
              for (let j = 0; j < data.specialTypesList.length; j++) {
                if (
                  data.relevanceTable[i].relevanceType ==
                  data.specialTypesList[j].key
                ) {
                  data.relevanceTable[i].relevanceType =
                    data.specialTypesList[j].value;
                }
              }
            }
          } else {
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };
    //关闭添加编辑弹窗操作
    const AddEditComponent = ref();
    const handleClose = () => {
      if (data.addEditVisible) {
        AddEditComponent.value.resetForm();
        data.addEditVisible = false;
      }
    };
    //发布
    const releaseFnc = (e) => {
      // 强制移除按钮焦点
      lostFocus(e);
      if (data.multipleSelection == 0) {
        ElMessage.error("请选择需要发布的文章");
        return;
      }
      if (data.multipleSelection.length > 1) {
        ElMessage.error("只能选择一个进行发布");
        return;
      }
      ElMessageBox.confirm(
        `是否将[${data.multipleSelection[0].title}]发布到PC端`,
        "发布",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          releasePost(data.multipleSelection[0].oldId);
        })
        .catch(() => {
          ElMessage("取消发布");
        });
    };
    const releasePost = async (id) => {
      data.loading = true;
      const res = await ArticleHtml(id);
      if (res && res.code == 1) {
        data.loading = false;
        ElMessageBox.alert(res.message, {
          confirmButtonText: "确定",
        });
        updateList();
      } else {
        data.loading = false;
        ElMessageBox.alert(res.message, {
          confirmButtonText: "确定",
        });
      }
    };
const doEvent = function (btn, row) {
  try {
    data.multipleSelection = [];
    data.multipleSelection.push(row);
    eval(btn.split("(")[0] + `()`);
  }
  catch (err) {
    console.log(err);
    
    ElMessageBox.alert("err");
  }
}
    const btnHandle = (val) => {
      try {
        eval(val);
      } catch (error) {
        ElMessage.error("按钮事件不存在");
      }
    };
    const btnLeftList = ref([]);
    const buttonList = ref([]);
    const btnOnList = (val) => {
      btnLeftList.value = val ? val : [];
    }
    const btnInTable = async (val) => {
      if (val?.length > 0) {
        // 先设置按钮数据并插入列定义
        buttonList.value = val;
        data.headerData.splice(1, 0, {
          label: "操作",
          prop: "inTable",
          align: "center",
          fixed: "left",
          custom: true,
          isInTable: true,
        });
        // 等待 DOM 更新，确保表格单元格渲染完毕以便正确测量宽度
        await nextTick();
        await nextTick();
        // 获取操作按钮组的元素并测量宽度
        const opts = document.getElementsByClassName("optionDiv");
        let widthArr = [];
        Array.prototype.forEach.call(opts, function (item) {
          if (item.offsetWidth > 0) {
            widthArr.push(item.offsetWidth);
          }
        });
        if (widthArr.length > 0 && buttonList.value?.length > 0) {
          let index = 0;
          var obj = {};
          for (var i = 0; i < data.headerData.length; i++) {
            if (data.headerData[i].label == "操作") {
              index = i;
              obj = JSON.parse(JSON.stringify(data.headerData[i]));
              // 使用数字类型宽度（px由组件处理），并留出一定内边距
              obj.width = Math.max(...widthArr) + 24;
            }
          }
          data.headerData[index] = obj;
        }
      }
    };
    return {
      //解构Data结构体，让模板可以直接调用Data里面的对象
      ...toRefs(data),
      getArticleList,
      searchFnc,
      updateList,
      addFnc,
      editFnc,
      deleteFnc,
      closeDialog,
      changePagination,
      changeCascader,
      changeRelevance,
      handleSelection,
      openChannelCount,
      AddEditComponent,
      handleClose,
      releaseFnc,
      openCourseDetail,
      UrlOpen,
      offshelf,
      grounding,
      changeRelevanceType,
      resultHandle,
      btnInTable,
      btnLeftList,
      buttonList,
      btnOnList,
      btnHandle,
      doEvent,
      isFullscreen,
      toggleFullscreen,
      FullScreen: require('element-plus').ElIconFullScreen,
      Minus: require('element-plus').ElIconMinus,
    };
  },
};
</script>
<style scoped>
.tooltip {
  width: 300px;
}
</style>
<style scoped lang="scss">
</style>
<style scoped>
.dialog-title {
  font-size: 18px;
  /* font-weight: bold; */
}
</style>
<style scoped>
::v-deep .el-dialog.is-fullscreen {
  height: 100vh !important;
  max-width: 100vw !important;
  margin: 0 !important;
}
.full-screen {
  margin-top: -8px;
  
}
</style>



